<template>
  <div class="text-center">
    <img v-if="isNew" src="../../../assets/img/new.gif" class="cal-img-new"/>
    <img v-if="isCancelled" src="../../../assets/img/calendar_cancel_icon.gif" class="cal-cancel-img"/>
    <img v-if="isCancelledToday" src="../../../assets/img/cancel_not_gif.png" class="cal-cancel-img"/>
  </div>
</template>
<script>
export default {
  props:[
    "isNew",
    "isCancelled",
    "isCancelledToday"
  ],
  name: "hc-calendar-hightlight",
}
</script>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/hc-calendar-hightlight.vue